<div class="sheet-grid" [style.grid-template-columns]="gridTemplateColumns"
  [style.grid-template-rows]="gridTemplateRows" [style.aspect-ratio]="sheetAspectRatio" data-testid="sheet-grid">
  @for (row of rowIndices; track row) {
  <span class="row-number" [style.grid-column]="'1 / span 1'" [style.grid-row]="getRowNumberGridRow(row)"
    aria-hidden="true">{{ row + 1 }}</span>
  }
  @for (position of positions; track position) {
  <button class="grid-cell" [class.selected]="isLabeled(position)" [class.used]="isUsed(position)"
    [style.grid-column]="getGridColumn(position)" [style.grid-row]="getGridRow(position)"
    (click)="onCellClick(position)" (contextmenu)="onCellRightClick($event, position)"
    (keydown)="onKeydown($event, position)" [attr.data-testid]="'grid-cell-' + position"
    [attr.aria-pressed]="isLabeled(position)"
    [attr.aria-label]="'Label position ' + (position + 1) + (isLabeled(position) ? ' – labeled' : isUsed(position) ? ' – used' : ' – blank')"
    type="button">
    @if (labelLayout && isLabeled(position)) {
    <app-label-preview [layout]="labelLayout" [checkpointName]="checkpointName" [formName]="formName"
      [showCode]="showCode" [showCheckpointName]="showCheckpointName" [showFormName]="showFormName"
      [selected]="isLabeled(position)" [checkpointNameFontSize]="checkpointNameFontSize"
      [formNameFontSize]="formNameFontSize" [fontFamily]="fontFamily" [codeType]="codeType" [qrX]="qrX" [qrY]="qrY"
      [qrWidth]="qrWidth" [checkpointNameX]="checkpointNameX" [qrHeight]="qrHeight" [checkpointNameY]="checkpointNameY"
      [checkpointNameWidth]="checkpointNameWidth" [checkpointNameHeight]="checkpointNameHeight" [formNameX]="formNameX"
      [formNameY]="formNameY" [formNameWidth]="formNameWidth" [formNameHeight]="formNameHeight"
      [showSerialNumber]="showSerialNumber" [serialNumber]="positionSerials.get(position) ?? ''"
      [serialNumberFontSize]="serialNumberFontSize" [serialNumberX]="serialNumberX" [serialNumberY]="serialNumberY"
      [serialNumberWidth]="serialNumberWidth" [serialNumberHeight]="serialNumberHeight"
      [labelWidthMm]="sheetFormat.label_width" [labelHeightMm]="sheetFormat.label_height" [debug]="debug" />
    }
  </button>
  }
</div>